import { Input } from '@components'
import cn from '@integrations/classnames'
import type { PaymentOptionResponse } from 'mmfintech-backend-api/types'
import { formatMoney, tr, translateError } from 'mmfintech-commons'
import { ErrorDisplay, InputLabel } from 'mmfintech-portal-commons'
import styles from './SelectPaymentMethod.module.scss'

interface Props {
  paymentOption: PaymentOptionResponse
  paymentOptionError: unknown
  onChange: (value: string) => void
  paymentOptions: PaymentOptionResponse[]
  paymentOptionsError?: unknown
  required?: boolean
}

function SelectPaymentMethod({
  paymentOption,
  paymentOptionError,
  onChange,
  paymentOptions,
  paymentOptionsError,
  required
}: Props) {
  const dropDownOptions = paymentOptions?.map((po: PaymentOptionResponse) => {
    const { currency, feePercent, feeFlat, feeFlatCurrency, paymentMethod } = po

    const feeFlatFormatted = feeFlat
      ? `${formatMoney(feeFlat, feeFlatCurrency || currency)} ${feePercent ? ' + ' : ''}`
      : ''
    const feePercentFormatted = feePercent ? `${feePercent}%` : ''
    const fee =
      feeFlat || feePercent
        ? ` (${feeFlatFormatted}${feePercentFormatted} ${tr('FRONTEND.DEPOSIT.LABEL_FEE', 'Fee')})`
        : ''

    return { value: paymentMethod, label: tr(`METADATA.PAYMENT_OPTIONS.${paymentMethod}`, paymentMethod) + fee }
  })

  if (paymentOptionsError) {
    return <ErrorDisplay error={paymentOptionsError} />
  }

  return (
    <div className={cn(styles['select-payment-method-dropdown-wrapper'], 'select-payment-method-dropdown-wrapper')}>
      <InputLabel
        label={tr('FRONTEND.DEPOSIT.SELECT_METHOD_TITLE', 'Payment Method')}
        required={required}
        requiredPosition='right'
      />
      <Input
        name='select-method-dropdown'
        required
        type='select'
        options={dropDownOptions}
        error={translateError(paymentOptionError)}
        value={paymentOption?.paymentMethod ?? ''}
        placeholder={tr('FRONTEND.DEPOSIT.SELECT_METHOD', 'Select Method')}
        onChange={(_name: string, value: string) => onChange?.(value)}
      />
    </div>
  )
}

export default SelectPaymentMethod
